// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vduC","index":"styles_index__2M5p7"};